import "./App.css";
import { Footer } from "./components/Footer";
import { Router } from "./Router";
import { useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { Link, useLocation } from "react-router-dom";
import Logo from "./assets/image/Aysa-Wordmark.svg";
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  Link as MuiLink,
} from "@mui/material";

function App() {
  const location = useLocation();

  useEffect(() => {
    if (!location.pathname.startsWith("/dashboard")) {
      let id = localStorage.getItem("browserId") || uuidv4();
      localStorage.setItem("browserId", id);

      axios
        .post(
          `https://api.the-aysa.com/create-visitor-value`,
          { browser_id: id },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .catch((err) =>
          console.error("Visitor API error:", err.response?.data || err.message)
        );
    }
  }, [location.pathname]);

  return (
    <>
      <div className="App">
        {/* ✅ Modern MUI Header */}
        <AppBar
          position="static"
          className="headerSyle"
          sx={{
            backgroundColor: "#2D2D2D",
            color: "#000",
            boxShadow: "none",
            borderBottom: "1px solid #e0e0e0",
            py: 1,
          }}
        >
          <Toolbar
            sx={{
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              padding: "0px !important",
            }}
            className="header-main"
          >
            <Box display="flex" alignItems="center" gap={2}>
              <Link to="/">
                <img src={Logo} alt="logo" />
              </Link>
            </Box>

            <Box
              display="flex"
              alignItems="center"
              gap={3}
              className="headerMenu"
            >
              <MuiLink
                component={Link}
                to="/about"
                sx={{
                  color: "#F3F3F3",
                  textDecoration: "none",
                  fontWeight: 500,
                }}
              >
                About
              </MuiLink>
              <MuiLink
                component={Link}
                to="/contact"
                sx={{
                  color: "#F3F3F3",
                  textDecoration: "none",
                  fontWeight: 500,
                }}
              >
                Contact
              </MuiLink>
            </Box>
          </Toolbar>
        </AppBar>

        {/* Page content */}

        <Router />
        <Footer />
      </div>
    </>
  );
}

export default App;
